export const frola = `
    .fr-rounded, .fr-img-caption.fr-rounded img {
          border-radius: 10px;
          -moz-border-radius: 10px;
          -webkit-border-radius: 10px;
          -moz-background-clip: padding;
          -webkit-background-clip: padding-box;
          background-clip: padding-box;
    }
     .fr-bordered, .fr-img-caption.fr-bordered img {
          border: solid 5px #ccc;
    }
     .fr-bordered {
          -webkit-box-sizing: content-box;
          -moz-box-sizing: content-box;
          box-sizing: content-box;
    }
     .fr-img-caption.fr-bordered img {
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
    }
     .fr-shadow, .fr-img-caption.fr-shadow img {
          -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px 1px rgba(0, 0, 0, 0.16);
          -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px 1px rgba(0, 0, 0, 0.16);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px 1px rgba(0, 0, 0, 0.16);
    }
     .fr-view {
          word-wrap: break-word;
    }
     .fr-view span[style~='color:'] a {
          color: inherit;
    }
     .fr-view strong {
          font-weight: 600;
    }
     .fr-view table {
          border: none;
          border-collapse: collapse;
          empty-cells: show;
          max-width: 100%;
    }
     .fr-view table td {
          min-width: 5px;
          padding-left: 8px;
          padding-right: 8px;
    }
     .fr-view table td ul {
          margin-left: 0px;
    }
     .fr-view table.fr-dashed-borders td, .fr-view table td, .fr-view table th {
          border: 1px solid #ddd;
    }
     .fr-view table td:empty, .fr-view table th:empty {
          height: 20px;
    }
     .fr-view table td.fr-highlighted, .fr-view table th.fr-highlighted {
          border: 1px double red;
    }
     .fr-view table td.fr-thick, .fr-view table th.fr-thick {
          border-width: 2px;
    }
     .fr-view table th {
          background: #e6e6e6;
    }
     .fr-view hr {
          clear: both;
          user-select: none;
          -o-user-select: none;
          -moz-user-select: none;
          -khtml-user-select: none;
          -webkit-user-select: none;
          -ms-user-select: none;
          page-break-after: always;
    }
     .fr-view .fr-file {
          position: relative;
    }
     .fr-view .fr-file::after {
          position: relative;
          content: '\\1F4CE';
          font-weight: normal;
    }
     .fr-view pre {
          white-space: pre-wrap;
          word-wrap: break-word;
          overflow: visible;
    }
     .fr-view[dir='rtl'] blockquote {
          border-left: none;
          border-right: solid 2px #5e35b1;
          margin-right: 0;
          padding-right: 5px;
          padding-left: 0px;
    }
     .fr-view[dir='rtl'] blockquote blockquote {
          border-color: #00bcd4;
    }
     .fr-view[dir='rtl'] blockquote blockquote blockquote {
          border-color: #43a047;
    }
     .fr-view blockquote {
          border-left: solid 2px #b394f2;
          margin-left: 32px;
          padding-left: 22px;
          color: #b394f2;
    }
     @media screen and (max-width: 905px) {
          .fr-view blockquote {
               margin: 16px 0px 16px 8px;
         }
    }
     .fr-view blockquote p {
          font-size: 18px;
          line-height: 30px;
          font-style: italic;
          font-weight: 600;
    }
     @media screen and (max-width: 905px) {
          .fr-view blockquote p {
               font-size: 16px;
               line-height: 26px;
         }
    }
     .fr-view blockquote blockquote {
          border-color: #00bcd4;
          color: #00bcd4;
    }
     .fr-view blockquote blockquote blockquote {
          border-color: #43a047;
          color: #43a047;
    }
     .fr-view span.fr-emoticon {
          font-weight: normal;
          font-family: 'Open sans', sans-serif;
          display: inline;
          line-height: 0;
    }
     .fr-view span.fr-emoticon.fr-emoticon-img {
          background-repeat: no-repeat !important;
          font-size: inherit;
          height: 1em;
          width: 1em;
          min-height: 20px;
          min-width: 20px;
          display: inline-block;
          margin: -0.1em 0.1em 0.1em;
          line-height: 1;
          vertical-align: middle;
    }
     .fr-view .fr-text-gray {
          color: #aaa !important;
    }
     .fr-view .fr-text-bordered {
          border-top: solid 1px #222;
          border-bottom: solid 1px #222;
          padding: 10px 0;
    }
     .fr-view .fr-text-spaced {
          letter-spacing: 1px;
    }
     .fr-view .fr-text-uppercase {
          text-transform: uppercase;
    }
     .fr-view img {
          position: relative;
          max-width: 100%;
    }
     .fr-view .fr-dib {
          margin: 5px auto;
          display: block;
          float: none;
          vertical-align: top;
          text-align: center;
    }
     .fr-view .fr-dib.fr-fil {
          margin-left: 0;
          text-align: left;
    }
     .fr-view .fr-dib.fr-fir {
          margin-right: 0;
          text-align: right;
    }
     .fr-view .fr-dii {
          display: inline-block;
          float: none;
          vertical-align: bottom;
          margin-left: 5px;
          margin-right: 5px;
          max-width: calc(100% - (2 * 5px));
          height: auto;
    }
     .fr-view .fr-dii.fr-fil {
          float: left;
          margin: 5px 5px 5px 0;
          max-width: calc(100% - 5px);
    }
     .fr-view .fr-dii.fr-fir {
          float: right;
          margin: 5px 0 5px 5px;
          max-width: calc(100% - 5px);
    }
     .fr-view span.fr-img-caption {
          position: relative;
          max-width: 100%;
    }
     .fr-view span.fr-img-caption.fr-dib {
          margin: 16px auto;
          margin-top: 32px;
          margin-bottom: 0px;
          display: block;
          float: none;
    }
     .fr-view span.fr-img-caption.fr-dib.fr-fil {
          margin-left: 0;
          text-align: left;
    }
     .fr-view span.fr-img-caption.fr-dib.fr-fir {
          margin-right: 0;
          text-align: right;
    }
     .fr-view span.fr-img-caption.fr-dii {
          display: inline-block;
          float: none;
          vertical-align: bottom;
          margin-left: 5px;
          margin-right: 5px;
          max-width: calc(100% - (2 * 5px));
    }
     .fr-view span.fr-img-caption.fr-dii.fr-fil {
          float: left;
          margin: 0px 24px 0px 0;
          max-width: calc(100% - 5px);
    }
     @media screen and (max-width: 600px) {
          .fr-view span.fr-img-caption.fr-dii.fr-fil {
               max-width: 50vw;
         }
    }
     .fr-view span.fr-img-caption.fr-dii.fr-fir {
          float: right;
          margin: 5px 0 5px 5px;
          max-width: calc(100% - 5px);
    }
     .fr-view .fr-video {
          text-align: center;
          position: relative;
          padding-top: 16px;
    }
     .fr-view .fr-video > * {
          -webkit-box-sizing: content-box;
          -moz-box-sizing: content-box;
          box-sizing: content-box;
          max-width: 100%;
          border: none;
    }
     .fr-view .fr-video.fr-dvb {
          display: block;
          clear: both;
    }
     .fr-view .fr-video.fr-dvb.fr-fvl {
          text-align: left;
    }
     .fr-view .fr-video.fr-dvb.fr-fvr {
          text-align: right;
    }
     .fr-view .fr-video.fr-dvi {
          display: inline-block;
    }
     .fr-view .fr-video.fr-dvi.fr-fvl {
          float: left;
    }
     .fr-view .fr-video.fr-dvi.fr-fvr {
          float: right;
    }
     .fr-view a.fr-strong {
          font-weight: 700;
    }
     .fr-view a.fr-green {
          color: green;
    }
     .fr-view .fr-img-caption {
          text-align: center;
    }
     .fr-view .fr-img-caption .fr-img-wrap {
          padding: 0px;
          display: inline-block;
          margin: auto;
          text-align: center;
          width: 100%;
    }
     .fr-view .fr-img-caption .fr-img-wrap img {
          display: block;
          margin: auto;
    }
     .fr-view .fr-img-caption .fr-img-wrap > span {
          font-family: 'Open Sans';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 14px;
         /* identical to box height, or 117% */
          letter-spacing: -0.4px;
         /* Neutral/60 */
          color: #868686;
          display: flex;
          padding-top: 4px;
    }
     .fr-view button.fr-rounded, .fr-view input.fr-rounded, .fr-view textarea.fr-rounded {
          border-radius: 10px;
          -moz-border-radius: 10px;
          -webkit-border-radius: 10px;
          -moz-background-clip: padding;
          -webkit-background-clip: padding-box;
          background-clip: padding-box;
    }
     .fr-view button.fr-large, .fr-view input.fr-large, .fr-view textarea.fr-large {
          font-size: 24px;
    }
    /** * Image style. */
     a.fr-view.fr-strong {
          font-weight: 700;
    }
     a.fr-view.fr-green {
          color: green;
    }
    /** * Link style. */
     span.fr-view {
          position: relative;
          max-width: 100%;
    }
     .fr-view.fr-dib {
          margin: 5px auto;
          display: block;
          float: none;
          vertical-align: top;
    }
     .fr-view.fr-dib.fr-fil {
          margin-left: 0;
          text-align: left;
    }
     .fr-view.fr-dib.fr-fir {
          margin-right: 0;
          text-align: right;
    }
     .fr-view.fr-dii {
          display: inline-block;
          float: none;
          vertical-align: bottom;
          margin-left: 5px;
          margin-right: 5px;
          max-width: calc(100% - (2 * 5px));
    }
     .fr-view.fr-dii.fr-fil {
          float: left;
          margin: 5px 5px 5px 0;
          max-width: calc(100% - 5px);
    }
     .fr-view.fr-dii.fr-fir {
          float: right;
          margin: 5px 0 5px 5px;
          max-width: calc(100% - 5px);
    }
     span.fr-img-caption.fr-view {
          position: relative;
          max-width: 100%;
    }
     span.fr-img-caption.fr-view.fr-dib {
          margin: 5px auto;
          display: block;
          float: none;
          vertical-align: top;
    }
     span.fr-img-caption.fr-view.fr-dib.fr-fil {
          margin-left: 0;
          text-align: left;
    }
     span.fr-img-caption.fr-view.fr-dib.fr-fir {
          margin-right: 0;
          text-align: right;
    }
     span.fr-img-caption.fr-view.fr-dii {
          display: inline-block;
          float: none;
          vertical-align: bottom;
          margin-left: 5px;
          margin-right: 5px;
          max-width: calc(100% - (2 * 5px));
    }
     span.fr-img-caption.fr-view.fr-dii.fr-fil {
          float: left;
          margin: 5px 5px 5px 0;
          max-width: calc(100% - 5px);
    }
     span.fr-img-caption.fr-view.fr-dii.fr-fir {
          float: right;
          margin: 5px 0 5px 5px;
          max-width: calc(100% - 5px);
    }
     .fr-view p, .fr-view div  {
          font-size: 18px;
          line-height: 30px;
          color: #353535;
    }
     @media screen and (max-width: 905px) {
          .fr-view p, .fr-view div {
               font-size: 16px;
               line-height: 26px;
         }
    }
     @media screen and (max-width: 600px) {
          .fr-view p, .fr-view div {
               margin-bottom: 12px;
         }
    }
     .fr-view a {
          text-decoration: underline !important;
          color: #982ea9;
    }
     .fr-view a:hover {
          color: #611d6c;
    }
     .fr-view a:visited {
          color: #22385e;
    }
     .fr-view h2 {
          font-family: 'Open Sans';
          font-style: normal;
          font-weight: 700;
          font-size: 32px;
          line-height: 44px;
          color: #353535;
          padding-top: 16px;
          padding-bottom: 16px;
          margin: 0px;
    }
     @media screen and (max-width: 905px) {
          .fr-view h2 {
               font-size: 26px;
               line-height: 38px;
         }
    }
     @media screen and (max-width: 600px) {
          .fr-view h2 {
               padding-top: 12px;
               padding-bottom: 12px;
         }
    }
     .fr-view h3 {
          font-family: 'Open Sans';
          font-style: normal;
          font-weight: 700;
          font-size: 26px;
          line-height: 38px;
          color: #353535;
          padding-top: 16px;
          padding-bottom: 16px;
          margin: 0px;
    }
     @media screen and (max-width: 905px) {
          .fr-view h3 {
               font-size: 20px;
               line-height: 30px;
               font-weight: 600;
         }
    }
     @media screen and (max-width: 600px) {
          .fr-view h3 {
               padding-top: 12px;
               padding-bottom: 12px;
         }
    }
     .fr-view table tbody {
          font-size: 14px;
          color: #353535;
          line-height: 24px;
          vertical-align: baseline;
    }
     .fr-view table thead tr th {
          border: 1px solid #8155db !important;
          font-family: 'Open Sans';
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
         /* identical to box height, or 150% */
         /* Neutral/100 */
          color: #353535;
          flex-direction: row;
          align-items: center;
          text-align: start;
          padding: 8px;
          position: static;
          width: 220px;
          left: 0px;
          top: 0px;
         /* Semantic/Info Purple Light */
          background: #f2ecfe !important;
    }
     .fr-view table ul {
          font-size: 14px;
          line-height: 24px;
          padding-left: 16px;
    }
     .fr-view table ul li {
          list-style: none;
          position: relative;
    }
     .fr-view table ul li::before {
          content: '•';
          position: absolute;
          left: -10px;
    }
     .fr-view ul {
          font-size: 18px;
          line-height: 30px;
          margin-left: 12px;
          padding: 0px;
          margin-top: 0px;
          margin-bottom: 0px !important;
         /* Neutral/100 */
          color: #353535;
    }
     @media screen and (max-width: 905px) {
          .fr-view ul {
               font-size: 16px;
               line-height: 26px;
         }
    }
     .fr-view ul li {
          padding-left: 2px;
          margin-bottom: 0px;
          list-style: none;
          position: relative;
    }
     @media screen and (max-width: 600px) {
          .fr-view ul li {
               padding-bottom: 0px;
         }
    }
     .fr-view ul li::before {
          content: '•';
          position: absolute;
          left: -10px;
    }
`;
